export const LeaseSettlementRouting = [
  {
    path: "/lease-config/lease-settlement/list",
    name: "lease-settlement-list",
    meta: { title: "租赁结算" },
    component: () => import("@/views/lease-config/lease-settlement/list/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-settlement/create",
    name: "lease-settlement-create",
    meta: { title: "新增租赁结算",comName:'leaseConfigLeaseSettlementFormCreate' },
    component: () => import("@/views/lease-config/lease-settlement/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-settlement/edit/:id",
    name: "lease-settlement-edit",
    meta: { title: "编辑租赁结算",comName:'leaseConfigLeaseSettlementFormCreate' },
    component: () => import("@/views/lease-config/lease-settlement/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/lease-config/lease-settlement/detail/:id",
    name: "lease-settlement-detail",
    meta: { title: "租赁结算详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-settlement/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/lease-config/lease-settlement/flowPrint/:id",
    name: "lease-settlement-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/lease-config/lease-settlement/flow-print/index.vue"
      ),
  },
];